const { brokerCustomWalletEditablePortfolio } = require('./brokerCustomWalletEditablePortfolio');
const brokerCustomWalletInterveners = require('./brokerCustomWalletInterveners');
const brokerCustomWalletInvestments = require('./brokerCustomWalletInvestments');
const brokerCustomWalletNotifications = require('./brokerCustomWalletNotifications');
const { brokerCustomWalletPortfolios } = require('./brokerCustomWalletPortfolios');

module.exports = {
    brokerCustomWalletEditablePortfolio,
    brokerCustomWalletInterveners,
    brokerCustomWalletInvestments,
    brokerCustomWalletNotifications,
    brokerCustomWalletPortfolios
}